import type { FC } from 'react';
import React from 'react';
import ErrorIcon from '../../../../icons/ErrorIcon';
import { Container, StyledText } from './style';

interface ErrorMessageProps {
  message: string | undefined;
}

export const ErrorMessage: FC<ErrorMessageProps> = ({ message }) => {
  return (
    <Container>
      <ErrorIcon />
      <StyledText>{message}</StyledText>
    </Container>
  );
};
